import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { BehaviorSubject, Observable, tap, finalize } from 'rxjs';
import { SessionService } from '@services/session.service';
import { MultiWheelQuestion } from '@longnecktech/splash-commons-fe/dist/types/multi-wheel/multi-wheel-question';

@Injectable({
  providedIn: 'root',
})
export class MatchupService {
  private http = inject(HttpClient);
  private session = inject(SessionService);

  private _matchup = new BehaviorSubject<MultiWheelQuestion | undefined>(
    undefined,
  );
  private _isLoading = new BehaviorSubject<boolean>(false);
  private _completed = new BehaviorSubject<boolean>(false);

  readonly matchup$ = this._matchup.asObservable();
  readonly isLoading$ = this._isLoading.asObservable();
  readonly completed$ = this._completed.asObservable();

  get matchup(): MultiWheelQuestion | undefined {
    return this._matchup.getValue();
  }

  get completed(): boolean {
    return this._completed.getValue();
  }

  fetchMatchup(): Observable<MultiWheelQuestion> {
    this._isLoading.next(true);
    const gameUuid = this.session.gameUuid;

    return this.http
      .post<MultiWheelQuestion>(
        `${environment.backendUrl}/api/multi-wheel/question/${gameUuid}`,
        {},
      )
      .pipe(
        tap((data) => {
          this._matchup.next(data);
          this.updateGameInnerSegments(data);
        }),
        finalize(() => {
          this._isLoading.next(false);
        }),
      );
  }

  /** Called when user clicks "SPIN THE WHEEL" — matchup flow is done */
  markCompleted(): void {
    this._completed.next(true);
  }

  clear(): void {
    this._matchup.next(undefined);
    this._completed.next(false);
  }

  setMatchupFromAssigned(question: MultiWheelQuestion): void {
    this._matchup.next(question);
    this.updateGameInnerSegments(question);
  }

  private updateGameInnerSegments(question: MultiWheelQuestion): void {
    const currentGame = this.session.getCurrentGame();
    if (currentGame && question.innerSegments?.length) {
      const updatedGame = {
        ...currentGame,
        innerSegments: question.innerSegments,
      };
      this.session.setCurrentGame(updatedGame);
    }
  }
}
